import axiosInstance from "./axiosInstance";

export async function createEvent(data) {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("content", data.content);
  formData.append("file", data.file);
  return await axiosInstance.post("/event", formData);
}

export async function getEvent() {
  return await axiosInstance.get("/event");
}

export async function deleteEvent(id) {
  return await axiosInstance.delete(`/event/${id}`);
}

export async function showEvent(id) {
  return await axiosInstance.get(`/event/${id}`);
}

export async function editEvent(data) {
  return await axiosInstance.put("/event", data)
}